import { usePatientTimer } from "@/hooks/usePatientTimer";
import { cn } from "@/lib/utils";

interface PatientTabTimerProps {
  customerWaitingSince: string;
}

export function PatientTabTimer({
  customerWaitingSince,
}: PatientTabTimerProps) {
  const { customerWaitingTimer } = usePatientTimer(customerWaitingSince);

  return (
    <p data-testid="patient-timer" className={cn("whitespace-nowrap ml-auto")}>
      {customerWaitingTimer}
    </p>
  );
}
